
        var result = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js!./inventory-tree-holder.scss");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/components/inventory-main/inventory-tree/tree-holder/inventory-tree-holder.scss
// module id = p2if
// module chunks = 0